module.exports = __webpack_public_path__ + "static/media/service-ecommerce.bb0c674c.png";